import React from 'react'
import type { Podcast } from '../../../types/podcast'

import type { LoadingActivity } from '../state/editor-store'

export type VoiceOption = {
  id: string
  name?: string | null
  description?: string | null
  labels?: { accent?: string | null; age?: string | null; description?: string | null; gender?: string | null } | null
  previewUrl?: string | null
  isDefaultA?: boolean
  isDefaultB?: boolean
}

export type PodcastEditorContextType = {
  id: string
  podcast: Podcast
  isLoading: boolean
  isError: boolean
  voices: VoiceOption[]
  hostAVoiceId: string
  hostBVoiceId: string
  editingTitle: boolean
  titleDraft: string
  // New audio settings
  speed: number
  volume: number
  emotion: string
  // ttsMode removed
  languageIso: string
  loadingActivity: LoadingActivity | null
  isGeneratingAudio: boolean
  isGeneratingScript: boolean
  // actions
  setHostAVoiceId: (id: string) => Promise<void>
  setHostBVoiceId: (id: string) => Promise<void>
  setSpeed: (v: number) => Promise<void>
  setVolume: (v: number) => Promise<void>
  setEmotion: (v: string) => Promise<void>
  setLanguageIso: (iso: string) => Promise<void>
  beginEditTitle: () => void
  cancelEditTitle: () => void
  setTitleDraft: (v: string) => void
  saveTitle: () => Promise<void>
  refetchAll: () => Promise<void>
  setLineText: (lineId: string, text: string) => void
  deleteLine: (lineId: string) => void
  addLineBelow: (afterLineId: string) => void
  setLineHost: (lineId: string, host: 'A' | 'B') => void
  setLineEmotion: (lineId: string, emotion: string) => void
}

export const PodcastEditorContext = React.createContext<PodcastEditorContextType | null>(null)
